var _defs, _use, _use2, _g, _mask;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCompare({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "01F31120-AA46-4BE0-B794-D384089243A4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 300,
    height: 520,
    rx: 4
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-8.3%",
    y: "-4.4%",
    width: "116.7%",
    height: "109.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: 0,
    width: 300,
    height: 520,
    rx: 4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "PLP",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01-PLP-choose-your-options",
    transform: "translate(-74.000000, -500.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(14.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background",
    style: {
      mixBlendMode: "multiply"
    }
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Plus",
    transform: "translate(60.000000, 486.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2861406,10.62325 L15.3001406,10.63725 L17.6321406,12.96825 C17.8101406,13.03925 17.9371406,13.22225 17.9371406,13.43725 L17.9371406,13.45025 C17.9411406,13.57025 17.9001406,13.69125 17.8131406,13.78625 L15.3001406,16.29925 C15.1171406,16.48325 14.8201406,16.48325 14.6371406,16.29925 C14.4581406,16.12225 14.4541406,15.83425 14.6241406,15.65125 L14.6371406,15.63625 L16.3371406,13.93725 L2.46814056,13.93725 C2.20914056,13.93725 2.00014056,13.71325 2.00014056,13.43725 C2.00014056,13.16725 2.20014056,12.94725 2.45114056,12.93725 L16.2731406,12.93725 L14.6371406,11.30025 C14.4581406,11.12125 14.4541406,10.83525 14.6241406,10.65125 L14.6371406,10.63725 C14.8151406,10.45825 15.1021406,10.45425 15.2861406,10.62325 Z M5.30014056,3.13725 C5.47914056,3.31525 5.48314056,3.60225 5.31314056,3.78525 L5.30014056,3.80025 L3.66314056,5.43725 L17.4691406,5.43725 C17.7281406,5.43725 17.9381406,5.66125 17.9381406,5.93725 C17.9381406,6.20725 17.7371406,6.42725 17.4861406,6.43725 L3.59914056,6.43725 L5.30014056,8.13725 C5.47914056,8.31525 5.48314056,8.60225 5.31314056,8.78525 L5.30014056,8.80025 C5.12214056,8.97825 4.83514056,8.98225 4.65114056,8.81325 L2.13714056,6.30025 C2.04214056,6.20525 1.99714056,6.08025 2,5.95525 L2,5.93725 C2,5.72325 2.12514056,5.54125 2.30314056,5.46925 L4.63714056,3.13725 C4.82014056,2.95425 5.11714056,2.95425 5.30014056,3.13725 Z",
    id: "Combined-Shape"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Background",
    style: {
      mixBlendMode: "multiply"
    }
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompare);
export default __webpack_public_path__ + "static/media/compare.7a2f3abd.svg";
export { ForwardRef as ReactComponent };